/* tslint:disable */
/* eslint-disable */
/* @relayHash ebe034d3a9de6fcf1ccc3fda171440cd */

import { ConcreteRequest } from "relay-runtime";
export type AvatarUploadMutationVariables = {
    fileType: string;
    contentLength: number;
};
export type AvatarUploadMutationResponse = {
    readonly profileImageUploadRequest: {
        readonly successToken: string;
        readonly url: string;
    } | null;
};
export type AvatarUploadMutation = {
    readonly response: AvatarUploadMutationResponse;
    readonly variables: AvatarUploadMutationVariables;
};



/*
mutation AvatarUploadMutation(
  $fileType: String!
  $contentLength: Int!
) {
  profileImageUploadRequest(input: {fileType: $fileType, contentLength: $contentLength}) {
    successToken
    url
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "fileType",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "contentLength",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "profileImageUploadRequest",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentLength",
                            "variableName": "contentLength"
                        },
                        {
                            "kind": "Variable",
                            "name": "fileType",
                            "variableName": "fileType"
                        }
                    ]
                }
            ],
            "concreteType": "UploadFileResp",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "successToken",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "AvatarUploadMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "AvatarUploadMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "AvatarUploadMutation",
            "id": null,
            "text": "mutation AvatarUploadMutation(\n  $fileType: String!\n  $contentLength: Int!\n) {\n  profileImageUploadRequest(input: {fileType: $fileType, contentLength: $contentLength}) {\n    successToken\n    url\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '418857883cd9e0b24fe5c42c27e63c8e';
export default node;
